import * as React from 'react';
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  field: {
    margin: theme.spacing.unit,
  },
});

// @ts-ignore
const stylesHOF = withStyles(styles);

function TextFieldHOC(additionalConfig?: any) {
  class TextFieldComponent extends React.PureComponent<any, any> {
    public render() {
      const { field, value, onChange, classes } = this.props;
      return (
        <TextField
          id={field.field}
          label={field.label}
          value={value}
          onChange={onChange}
          className={classes.field}
          fullWidth
          required={field.required}
          {...additionalConfig}
        />
      );
    }
  }

  return stylesHOF(TextFieldComponent);
}

export default TextFieldHOC;



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/TextFieldHOC.tsx